import {
  Component,
  EventEmitter,
  input,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { LocalPrivilege, PrivilegesApi } from '../../../schemas/backend-api';
import { CommonModule } from '@angular/common';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatToggleWrapper } from '../../material-wrappers/mat-toggle-wrapper/mat-toggle-wrapper';
import {
  DEFAULT_ROLE_FORBIDDEN_PRIVILEGES,
  defaultPrivileges,
} from '../../../constants/privileges-local';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'andor-create-role',
  standalone: true,
  imports: [CommonModule, TranslatePipe, MatSlideToggle, MatToggleWrapper],
  templateUrl: './create-role.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './create-role.scss',
})
export class CreateRole implements OnInit {
  privileges = input.required<PrivilegesApi>();
  /**
   * When editing the default role, privileges the default role must never hold
   * (`DEFAULT_ROLE_FORBIDDEN_PRIVILEGES`) are shown off and disabled — the
   * default role is what every anonymous visitor gets. Enforced authoritatively
   * server-side; this just prevents creating the state through the UI.
   */
  isDefaultRole = input(false);
  @Output() changed = new EventEmitter<PrivilegesApi>();
  filteredPrivileges: [LocalPrivilege[], LocalPrivilege[]] = [[], []];

  protected isForbiddenForDefault(id: keyof PrivilegesApi): boolean {
    return DEFAULT_ROLE_FORBIDDEN_PRIVILEGES.some((privilege) => privilege === id);
  }

  protected isDisabled(id: keyof PrivilegesApi): boolean {
    return this.isDefaultRole() && this.isForbiddenForDefault(id);
  }

  ngOnInit(): void {
    const filtered = defaultPrivileges.filter((privilege) => {
      return privilege.show;
    });
    const middle = Math.ceil(filtered.length / 2);
    for (let i = 0; i < filtered.length; i++) {
      if (i < middle) {
        this.filteredPrivileges[0].push(filtered[i]);
      } else {
        this.filteredPrivileges[1].push(filtered[i]);
      }
    }
  }

  onToggle(id: keyof PrivilegesApi) {
    if (this.isDisabled(id)) return;
    const privileges: PrivilegesApi = this.privileges();
    privileges[id] = !privileges[id];
    this.changed.emit(privileges);
  }
}
